import {
  GET_COUNTRIES_LOADING,
  GET_COUNTRIES_SUCCESS,
  GET_COUNTRIES_FAILURE,
} from "redux/types";

const initialSate = {
  getCountriesLoading: false,
  countries: null,
  errors: null,
};

export const getCountriesReducer = (state = initialSate, action: any) => {
  switch (action.type) {
    case GET_COUNTRIES_LOADING:
      return { ...state, getCountriesLoading: action.payload };
    case GET_COUNTRIES_SUCCESS:
      return { ...state, countries: action.payload };
    case GET_COUNTRIES_FAILURE:
      return { ...state, errors: action.payload };
    default:
      return state;
  }
};
